import { HERO, TRUST_ITEMS } from "../data/mock";
import { Button } from "./ui/button";
import { ArrowRight, ChevronDown } from "lucide-react";
import { Link } from "react-router-dom";

export const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex flex-col justify-center overflow-hidden bg-[#FAFAF7]">
      {/* Subtle decorative elements */}
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-[#308795]/[0.04] rounded-full -translate-y-1/3 translate-x-1/3" />
      <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-[#E5BD77]/[0.06] rounded-full translate-y-1/3 -translate-x-1/4" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[900px] h-[900px] border border-[#308795]/[0.04] rounded-full" />

      <div className="relative max-w-7xl mx-auto px-6 pt-32 pb-16 lg:pt-40 lg:pb-24 w-full">
        <div className="max-w-3xl">
          {/* Eyebrow */}
          <div className="inline-flex items-center gap-2 bg-[#308795]/[0.08] text-[#308795] text-sm font-semibold px-4 py-1.5 rounded-full mb-8 animate-fade-in">
            <span className="w-2 h-2 bg-[#308795] rounded-full animate-pulse" />
            38+ Years Transforming SME Operations
          </div>

          {/* Headline */}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-[#2C2A2B] leading-[1.1] tracking-tight mb-4 animate-slide-up">
            {HERO.headline}
            <span className="text-[#308795]"> — </span>
            <span className="bg-gradient-to-r from-[#308795] to-[#45818e] bg-clip-text text-transparent">
              {HERO.headlineSuffix}
            </span>
          </h1>

          {/* Subheadline */}
          <p className="text-lg lg:text-xl text-[#6B6567] leading-relaxed max-w-2xl mb-10 animate-slide-up-delay">
            {HERO.subheadline}
          </p>

          {/* CTAs */}
          <div className="flex flex-col sm:flex-row gap-4 mb-20 animate-slide-up-delay-2">
            <Link to={HERO.primaryCTA.href}>
              <Button className="bg-[#308795] hover:bg-[#267580] text-white font-semibold px-8 py-6 text-base rounded-xl transition-all duration-300 hover:shadow-xl hover:shadow-[#308795]/20 hover:-translate-y-0.5 group">
                {HERO.primaryCTA.label}
                <ArrowRight className="ml-2 h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
              </Button>
            </Link>
            <a href={HERO.secondaryCTA.href}>
              <Button
                variant="outline"
                className="border-2 border-[#D5CFC9] text-[#494546] hover:border-[#308795] hover:text-[#308795] font-semibold px-8 py-6 text-base rounded-xl transition-all duration-300 hover:-translate-y-0.5 bg-white/60"
              >
                {HERO.secondaryCTA.label}
              </Button>
            </a>
          </div>
        </div>

        {/* Trust Strip */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 animate-fade-in-delay">
          {TRUST_ITEMS.map((item, i) => {
            const Icon = item.icon;
            return (
              <div
                key={i}
                className="flex items-center gap-4 bg-white/70 backdrop-blur-sm border border-[#E0D1BB]/30 rounded-xl px-5 py-4 transition-all duration-300 hover:shadow-md hover:border-[#308795]/20"
              >
                <div className="w-10 h-10 rounded-lg bg-[#308795]/[0.08] flex items-center justify-center shrink-0">
                  <Icon className="w-5 h-5 text-[#308795]" />
                </div>
                <div>
                  <div className="text-lg font-bold text-[#2C2A2B]">{item.value}</div>
                  <div className="text-xs text-[#8A8385] font-medium">{item.label}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <ChevronDown className="w-6 h-6 text-[#D5CFC9]" />
      </div>
    </section>
  );
};
